import { Grid } from "@mui/material";
import { ExerciseResultMetadata } from "@readyfit-common/models";

type GradeTestExerciseDefaultProps = {
  exercise: ExerciseResultMetadata;
};

export function GradeTestExerciseDefault(props: GradeTestExerciseDefaultProps) {
  return (
    <Grid container>
      <Grid item container xs={12}>
        <h1>{props.exercise.name}</h1>
      </Grid>
    </Grid>
  );
}
